export const JIRASERVICEMANAGEMENT = 'jiraServiceManagement' as const;

export type Solutions = typeof JIRASERVICEMANAGEMENT;
